export default {"src":"/uk/_next/static/media/spot-withdraw.af7e787f.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};